import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowCircleBrokenUpRight = function ArrowCircleBrokenUpRight(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2.3394 14.5896c-.891-3.3362-.0278-7.0434 2.5895-9.6607 3.9053-3.9052 10.2369-3.9052 14.1422 0 3.9052 3.9053 3.9052 10.2369 0 14.1422-2.6173 2.6173-6.3245 3.4804-9.6606 2.5895M15 15.0001v-6m0 0H9m6 0L5 19"
    })
  }));
};
export default ArrowCircleBrokenUpRight;